import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


function historyFunc() {
  const eventName = 'rntr_locationchange'
  const pushState = window.history.pushState;
  const replaceState = window.history.replaceState;
  window.history.pushState = function() {
    pushState.apply(window.history, arguments);
    window.dispatchEvent(new Event(eventName));
  };

  window.history.replaceState = function() {
    replaceState.apply(window.history, arguments);
    window.dispatchEvent(new Event(eventName));
  };

  window.addEventListener('popstate', function() {
    window.dispatchEvent(new Event(eventName))
  })
}

function init() {
  historyFunc()
  // console.log('Rntr: start')

  const el = document.createElement('DIV');
  el.className = 'rntr_cart-root'
  document.body.appendChild(el)

  const initialLocation =  window.location.origin + window.location.pathname;

  ReactDOM.render(
    <React.StrictMode>
      <App initialLocation={ initialLocation }/>
    </React.StrictMode>,
    el
  );
}

init()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
